import React from "react"

export default function IconExternalLink() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path d="M8 1C8 0.447715 8.44771 0 9 0H13C13.5523 0 14 0.447715 14 1V5C14 5.55228 13.5523 6 13 6C12.4477 6 12 5.55228 12 5V3.41356L6.37312 9.04044C5.9826 9.43096 5.34943 9.43096 4.95891 9.04044C4.56838 8.64992 4.56838 8.01675 4.95891 7.62623L10.5851 2H9C8.44771 2 8 1.55228 8 1ZM2.33333 4C2.24493 4 2.16014 4.03512 2.09763 4.09763C2.03512 4.16014 2 4.24493 2 4.33333V11.6667C2 11.7551 2.03512 11.8399 2.09763 11.9024C2.16014 11.9649 2.24493 12 2.33333 12H9.66667C9.75507 12 9.83986 11.9649 9.90237 11.9024C9.96488 11.8399 10 11.7551 10 11.6667V7.66667C10 7.11438 10.4477 6.66667 11 6.66667C11.5523 6.66667 12 7.11438 12 7.66667V11.6667C12 12.2855 11.7542 12.879 11.3166 13.3166C10.879 13.7542 10.2855 14 9.66667 14H2.33333C1.71449 14 1.121 13.7542 0.683417 13.3166C0.245833 12.879 0 12.2855 0 11.6667V4.33333C0 3.7145 0.245832 3.121 0.683417 2.68342C1.121 2.24583 1.7145 2 2.33333 2H6.33333C6.88562 2 7.33333 2.44772 7.33333 3C7.33333 3.55228 6.88562 4 6.33333 4H2.33333Z" />
    </svg>
  )
}
